"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneSupportMobileTablet = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const atome_1 = require("../../../components/atome");
const GlobalStyles_1 = require("../../../helper/GlobalStyles");
const Dashboard_web_style_1 = require("./Dashboard.web.style");
const PhoneSupportMobileTablet = (props) => {
    const { navigateTo } = props;
    return (react_1.default.createElement(react_native_1.View, { style: [Dashboard_web_style_1.styles.mobileHelpContainer] },
        react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.marginBottom15] },
            react_1.default.createElement(atome_1.Icon, { icon: "social", size: 40, color: "#3db384" })),
        react_1.default.createElement(atome_1.Text, { style: [Dashboard_web_style_1.styles.mobileHelpHeader] }, "Wir unterst\u00FCtzen Sie!"),
        react_1.default.createElement(react_native_1.TouchableOpacity, { style: [Dashboard_web_style_1.styles.button, Dashboard_web_style_1.styles.helpButton], onPress: () => react_native_1.Linking.openURL('tel:00493057712890') },
            react_1.default.createElement(atome_1.Text, { style: [Dashboard_web_style_1.styles.containerText] }, "Falls Sie Fragen haben oder unsicher sind, stehen wir Ihnen telefonisch pers\u00F6nlich unter 032 221 857 962 zur Verf\u00FCgung."))));
};
exports.PhoneSupportMobileTablet = PhoneSupportMobileTablet;
